import { Link } from "@inertiajs/react"
import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { MarketingMetadata } from "@/components/marketing/MarketingMetadata"
import type { MarketingPageProps } from "@/types/marketing"

export default function MarketingWebsiteReviewThankYou(props: MarketingPageProps) {
  const copy = props.locale === "hr" ? {
    nextTitle: "Dok čekate odgovor",
    nextBody: "Pogledajte kako smo povezali Čajankinu web-trgovinu s poslovanjem iza nje ili pregledajte što još gradimo.",
    work: "Čajanka — studija slučaja",
    services: "Što gradimo",
  } : {
    nextTitle: "While you wait",
    nextBody: "See how we connected Čajanka’s webshop with the business behind it, or explore what else we build.",
    work: "Čajanka — Case Study",
    services: "What we build",
  }

  return (
    <>
      <MarketingMetadata
        alternateUrls={props.alternate_urls}
        canonicalUrl={props.canonical_url}
        description={props.description}
        locale={props.locale}
        noindex
        socialImageUrl={props.social_image_url}
        title={props.title}
      />
      <MarketingLayout
        consultationHref={props.consultation_href}
        currentPageKey={props.page_key}
        footer={props.footer}
        homeHref={props.home_href}
        languageSwitch={props.language_switch}
        locale={props.locale}
        navigation={props.navigation}
      >
        <section className="booking-confirmation">
          <h1 className="type-marketing-hero-display">{props.heading}</h1>
          <p className="type-marketing-lead">{props.summary}</p>
          <div className="booking-confirmation-grid">
            <div>
              <strong>{copy.nextTitle}</strong>
              <p>{copy.nextBody}</p>
            </div>
            <div>
              <p><Link href={props.cajanka_href}>{copy.work} →</Link></p>
              <p><Link href={props.services_href}>{copy.services} →</Link></p>
            </div>
          </div>
          <p>
            {props.locale === "hr" ? "Ako odgovor ne stigne, javite se na" : "If the response does not arrive, email"}{" "}
            <a href="mailto:info@zmile.hr">info@zmile.hr</a>.
          </p>
        </section>
      </MarketingLayout>
    </>
  )
}
